import styles from "../index.scss";
import { TRANSLATION_KEY_CAROUSEL_SR_TEXT } from "../constants";
import { useRuntimeConstants } from "../../../context/runtimeConstants/RuntimeConstantsContext";

export const ScreenReaderInstructions = () => {
  const { getTranslation } = useRuntimeConstants();
  return (
    <span className={styles.screenreader}>
      <p>{getTranslation(TRANSLATION_KEY_CAROUSEL_SR_TEXT)}</p>
    </span>
  );
};
